<div class="modal-header bg-shradarkgreen">
    <div *ngIf="msg.titleHide == 0" class="page-subtitle1 text-white text-center">{{msg.title}}</div>
    <!-- <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
    </button> -->
</div>
<div class="modal-body">
    <div class="container">
        <div *ngIf="msg.headerHide == 0" class="page-subtitle1 mt-2 mb-3" [innerHTML]="msg.header"></div>
        <div *ngIf="msg.messageHide == 0" class="" [innerHTML]="msg.message"></div>

        <div class="text-center p-4">
            <button *ngIf="msg.doNotAgreeHide == 0" type="button" class="btn btn-doNotAgree btn-sm mb-3" (click)="doNotAgree()">{{msg.doNotAgreeText}}</button>
            <button *ngIf="msg.agreeHide == 0" type="button" class="btn btn-agree btn-sm" (click)="agree()">{{msg.agreeText}}</button>
        </div>
        <!-- <label *ngIf="msg.agreeHide == 0" class="mb-2">
            <input class="checkbox" type="checkbox" [checked]="agree" (change)="toggleAgree()">
            <span class="page-subtitle2">{{msg.agreeText}}</span>
        </label>
        <label *ngIf="msg.doNotAgreeHide == 0" class="mb-2">
            <input class="checkbox" type="checkbox" [checked]="doNotAgree" (change)="toggleDoNotAgree()">
            <span class="page-subtitle2">{{msg.doNotAgreeText}}</span>
        </label>
        <div [hidden]="frmvalid" class="errormsg mb-2">Please select an option</div> -->
    </div>
</div>
<div *ngIf="msg.btnCancelHide == 0 || msg.btnOkHide == 0" class="modal-footer">
    <button *ngIf="msg.btnCancelHide == 0" type="button" class="btn btn-Cancel btn-sm" (click)="decline()">{{msg.btnCancelText}}</button>
    <button *ngIf="msg.btnOkHide == 0" type="button" class="btn btn-Ok btn-sm" (click)="accept()">{{msg.btnOkText}}</button>
</div>
